import { countBy, keys, repeat } from 'ramda';
import { DEXFPriceUnitTypeCode, DEXFSalesPriceTypeCode } from './dexf';
import * as R from 'ramda';
export const getFamilyPrice = (article) => {
    return article.content?.priceInformation?.salesPrice.find((p) => p.typeCode === DEXFSalesPriceTypeCode.FAMILY_PRICE)?.priceInclTax;
};
export const getRegularPrice = (article) => {
    return article.content?.priceInformation?.salesPrice.find((p) => p.typeCode === DEXFSalesPriceTypeCode.REGULAR_PRICE)?.priceInclTax;
};
export const findLowestPrice = (products) => {
    return Math.min(...products.map(product => product.priceInformation.currentPrice));
};
export const findLowestPriceProduct = (products) => {
    if (!products || products.length === 0) {
        return undefined;
    }
    return products.reduce((lowestPriceProduct, product) => {
        if (!lowestPriceProduct?.priceInformation?.currentPrice ||
            product?.priceInformation?.currentPrice < lowestPriceProduct?.priceInformation?.currentPrice) {
            return product;
        }
        return lowestPriceProduct;
    }, {});
};
export const productsHaveSamePrice = (products) => {
    const prices = products.map(product => product.priceInformation?.currentPrice);
    return R.uniq(prices).length === 1;
};
export const pricesForArticles = (articles) => {
    const articlesWithPrice = articles.filter(art => !art.complimentary && art.valid);
    const articleCountById = countBy((art) => art.itemId)(articlesWithPrice);
    const articlesByPackage = keys(articleCountById).flatMap((articleId) => {
        const art = articles.find(a => a.itemId === articleId);
        const numberOfItemsInPackage = art.content?.priceUnit?.find(unit => unit.typeCode === DEXFPriceUnitTypeCode.packageQuantity)?.value || 1;
        const count = Math.ceil(articleCountById[articleId] / numberOfItemsInPackage);
        return repeat(art, count);
    });
    return articlesByPackage
        .map(a => a)
        .reduce((acc, value) => {
        if (value) {
            const familyPrice = getFamilyPrice(value);
            const regularPrice = getRegularPrice(value) || 0;
            const hasFamilyPrice = !!familyPrice;
            acc.regularPrice += regularPrice;
            if (hasFamilyPrice && familyPrice) {
                acc.currentPrice += familyPrice;
            }
            else {
                acc.currentPrice += regularPrice;
            }
        }
        return acc;
    }, { regularPrice: 0, currentPrice: 0 });
};
//# sourceMappingURL=prices.js.map